import { useTypedSelector } from "store/reducers/use-typed-selector";

export const useProjectDetailsEnabled = () => {
	const userChannelType = useTypedSelector(state => state.AuthReducer.userChannelType);

	if (!userChannelType || userChannelType === 'unset') {
		return false;
	}

	return true;
};
